import React from 'react';
import {isIframe} from "../../../helpers/utils";
import {getLocalSt, stKeys} from "../../../helpers/storage";
import {Link, useLocation} from "react-router-dom";
import Image from "react-bootstrap/Image";
import {toAbsoluteUrl} from "../../../helpers";
import IframeDropdownDesktopMenu from "./IframeDropdownDesktopMenu";
import DropdownDesktopMenu from "./DropdownDesktopMenu";
import {useAuth} from "../../../../app/modules/auth/core/action";

const DesktopMenu = () => {

    const {currentUser} = useAuth();
    const location = useLocation()
    const isHome = location.pathname.includes("game");
    const backBtn = !isHome && <Link to="/" className="p-1 btn-back"/>

    return (
        <div className="container-fluid d-none d-lg-flex">
            <div className="d-flex align-items-center" id="navbarSupportedContent">
                {(isIframe() && isHome) && <a href={getLocalSt(stKeys.redirectUrl)} className="btn-back">{""}</a>}
                {backBtn}
                <Link className="navbar-brand" to="/">
                    <Image
                        className="w-40px"
                        src={toAbsoluteUrl("/media/dice/logo-one-dice.png")}
                        alt="Logo"
                        loading="lazy"
                    />
                </Link>
                <div className="d-flex justify-content-center align-items-center">
                    <h2 className="text-light fw-bolder mt-3">Lotto6D</h2>
                </div>
            </div>
            <div className="d-flex justify-content-center align-items-center">
                <div className="text-light fs-4 fw-bolder text-uppercase">{currentUser?.username}</div>
            </div>

            {
                isIframe() ? <IframeDropdownDesktopMenu/> : <DropdownDesktopMenu/>
            }

        </div>
    );
};

export default DesktopMenu;